import script from "./SwipeActionsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwipeActionsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SwipeActionsContainer.vue?vue&type=style&index=0&id=137e8f65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137e8f65"]])

export default __exports__